import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../../../util/Rest';
import {
  SPLIT_PAY_METHOD,
  RECEIPT_LETTER_UPDATE,
  RECEIPT_LETTER_ENTRY,
  PAYMENT_USER_DEFINED_WINDOW,
  RETRO_EFFECTIVE_DATE,
} from '../../../../constants/Lookup';
import {CLIENT_MAINTENANCE} from '../../../../constants/MicroServiceConstants';

const initialValues = {
  debtorCashGeneralData: {},
  debtorCashGeneralStatus: null,
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'debtorCashGeneral',
  initialState: {...initialValues},
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchDebtorCashGeneralData: (state, action) => {
      state.debtorCashGeneralData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postDebtorCashGeneralData: (state, action) => {
      state.debtorCashGeneralStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },

    resetDebtorCashGeneralStatus: (state) => {
      state.debtorCashGeneralStatus = null;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {
  fetchStart,
  resetMsg,
  fetchDropDownData,
  resetDebtorCashGeneralStatus,
  fetchDebtorCashGeneralData,
  postDebtorCashGeneralData,
  fetchError,
} = slice.actions;

export const fetchDropDown = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [
          SPLIT_PAY_METHOD,
          RECEIPT_LETTER_UPDATE,
          RECEIPT_LETTER_ENTRY,
          PAYMENT_USER_DEFINED_WINDOW,
          RETRO_EFFECTIVE_DATE,
        ],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchDebtorCashGeneral = (clientNumber) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`${CLIENT_MAINTENANCE}/find/deptorgeneral/${clientNumber}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(fetchDebtorCashGeneralData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const postDebtorCashGeneral = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${CLIENT_MAINTENANCE}/save/deptorgeneral`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postDebtorCashGeneralData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetDebtorCashGeneralStatus());
  };
};
